import { ContentTypeCodenames } from "services/cms/models/contentTypeCodenames";
import type { Image } from "services/cms/models/image";
import type { Link } from "services/cms/models/link";
import { SponsorshipCard } from "services/cms/models/sponsorshipCard";

import breadcrumbResolver from "./breadcrumbResolver";
import type { ResolvedBreadcrumb } from "./breadcrumbResolver";
import imageResolver from "./imageResolver";
import type { ResolvedImage } from "./imageResolver";

export interface ResolvedSponsorshipCard {
    codename: string;
    title: string;
    text: string;
    image: ResolvedImage;
    link: ResolvedBreadcrumb;
    type: ContentTypeCodenames.SponsorshipCard;
}

const sponsorshipCardResolver = (data: SponsorshipCard): ResolvedSponsorshipCard => {
    return {
        codename: data.system.codename,
        title: data.elements.title.value,
        text: data.elements.text.value,
        image: imageResolver(data.elements.image.linkedItems[0] as Image),
        link: breadcrumbResolver(data.elements.link.linkedItems[0] as Link),
        type: ContentTypeCodenames.SponsorshipCard,
    };
};

export default sponsorshipCardResolver;
